export default __webpack_public_path__ + "static/media/wallet-connected.da8433f6.svg";